<div #dialogPopup
  class="color-picker"
  [class.open]="show"
  [style.display]="!show ? 'none' : 'block'"
  [style.visibility]="hidden ? 'hidden' : 'visible'"
  [style.top.px]="top"
  [style.left.px]="left"
  [style.position]="position"
  [style.height.px]="cpHeight"
  [style.width.px]="cpWidth"
  (click)="$event.stopPropagation()">
  @if (cpDialogDisplay === 'popup') {
    <div class="arrow arrow-{{cpUsePosition}}" [style.top.px]="arrowTop"></div>
  }

  @if (cpPresetColors?.length || cpAddColorButton) {
    <div class="preset-area">
      <div class="preset-label">{{cpPresetLabel}}</div>
      @if (cpPresetColors?.length) {
        <div class="{{cpPresetColorsClass}}">
          @for (color of cpPresetColors; track color) {
            <div
              class="preset-color"
              [class.active]="(color || '').toLowerCase() === (outputColor || initialColor || '').toLowerCase()"
              [style.backgroundColor]="color"
              (click)="setColorFromString(color)"
              [title]="color">
              @if (cpAddColorButton) {
                <span class="{{cpRemoveColorButtonClass}}" (click)="onRemovePresetColor($event, color)"></span>
              }
            </div>
          }
        </div>
      }
      @if (!cpPresetColors?.length && cpAddColorButton) {
        <div class="{{cpPresetEmptyMessageClass}}">{{cpPresetEmptyMessage}}</div>
      }
    </div>
  }

  @if ((cpColorMode || 1) === 1) {
    <div class="saturation-lightness" [slider] [rgX]="1" [rgY]="1" [style.background-color]="hueSliderColor" (newValue)="onColorChange($event)" (dragStart)="onDragStart('saturation-lightness')" (dragEnd)="onDragEnd('saturation-lightness')">
      <div class="cursor" [style.top.px]="slider?.v" [style.left.px]="slider?.s"></div>
    </div>
  }

  <div #hueSlider class="hue" [slider] [rgX]="1" [style.display]="(cpColorMode || 1) === 1 ? 'block' : 'none'" (newValue)="onHueChange($event)" (dragStart)="onDragStart('hue')" (dragEnd)="onDragEnd('hue')">
    <div class="cursor" [style.left.px]="slider?.h"></div>
  </div>

  <div #valueSlider class="value" [slider] [rgX]="1" [style.display]="(cpColorMode || 1) === 2 ? 'block': 'none'" (newValue)="onValueChange($event)" (dragStart)="onDragStart('value')" (dragEnd)="onDragEnd('value')">
    <div class="cursor" [style.right.px]="slider?.v"></div>
  </div>

  <div #alphaSlider class="alpha" [slider] [rgX]="1" [style.display]="cpAlphaChannel === 'disabled' ? 'none' : 'block'" [style.background-color]="alphaSliderColor" (newValue)="onAlphaChange($event)" (dragStart)="onDragStart('alpha')" (dragEnd)="onDragEnd('alpha')">
    <div class="cursor" [style.left.px]="slider?.a"></div>
  </div>

  @if ((cpColorMode || 1) !== 3) {
    <div
      class="box">
      @if ((eyeDropperSupported && cpEyeDropper) || cpAddColorButton) {
        <div>
          @if (eyeDropperSupported && cpEyeDropper) {
            <svg
              class="eyedropper-icon"
              [style.cursor]="eyeDropperSupported && cpEyeDropper ? 'pointer' : null" (click)="eyeDropperSupported && cpEyeDropper && onEyeDropper()"
              xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M17.66 5.41l.92.92-2.69 2.69-.92-.92 2.69-2.69M17.67 3c-.26 0-.51.1-.71.29l-3.12 3.12-1.93-1.91-1.41 1.41 1.42 1.42L3 16.25V21h4.75l8.92-8.92 1.42 1.42 1.41-1.41-1.92-1.92 3.12-3.12c.4-.4.4-1.03.01-1.42l-2.34-2.34c-.2-.19-.45-.29-.7-.29zM6.92 19L5 17.08l8.06-8.06 1.92 1.92L6.92 19z"/>
            </svg>
          }
          @if (cpAddColorButton) {
            <button type="button" class="{{cpAddColorButtonClass}}" [disabled]="cpPresetColors && cpPresetColors.length >= cpMaxPresetColorsLength" (click)="onAddPresetColor($event, selectedColor)">
              {{cpAddColorButtonText}}
            </button>
          }
        </div>
      }
      @if (!cpDisableInput && (cpColorMode || 1) === 1) {
        <div class="cmyk-text" [style.display]="format !== 3 ? 'none' : 'block'">
          <div class="box">
            <input type="number" pattern="[0-9]*" min="0" max="100" [text] [rg]="100" [value]="cmykText?.c" (keyup.enter)="onAcceptColor($event)" (newValue)="onCyanInput($event)" />
            <input type="number" pattern="[0-9]*" min="0" max="100" [text] [rg]="100" [value]="cmykText?.m" (keyup.enter)="onAcceptColor($event)" (newValue)="onMagentaInput($event)" />
            <input type="number" pattern="[0-9]*" min="0" max="100" [text] [rg]="100" [value]="cmykText?.y" (keyup.enter)="onAcceptColor($event)" (newValue)="onYellowInput($event)" />
            <input type="number" pattern="[0-9]*" min="0" max="100" [text] [rg]="100" [value]="cmykText?.k" (keyup.enter)="onAcceptColor($event)" (newValue)="onBlackInput($event)" />
            @if (cpAlphaChannel!=='disabled') {
              <input type="number" pattern="[0-9]+([\.,][0-9]{1,2})?" min="0" max="1" step="0.1" [text] [rg]="1" [value]="cmykText?.a" (keyup.enter)="onAcceptColor($event)" (newValue)="onAlphaInput($event)" />
            }
          </div>
          <div class="box">
            <div>C</div><div>M</div><div>Y</div><div>K</div>@if (cpAlphaChannel!=='disabled') {
            <div >A</div>
          }
        </div>
      </div>
    }
    @if (!cpDisableInput && (cpColorMode || 1) === 1 ) {
      <div class="hsla-text" [style.display]="format !== 2 ? 'none' : 'block'">
        <div class="box">
          <input type="number" pattern="[0-9]*" min="0" max="360" [text] [rg]="360" [value]="hslaText?.h" (keyup.enter)="onAcceptColor($event)" (newValue)="onHueInput($event)" />
          <input type="number" pattern="[0-9]*" min="0" max="100" [text] [rg]="100" [value]="hslaText?.s" (keyup.enter)="onAcceptColor($event)" (newValue)="onSaturationInput($event)" />
          <input type="number" pattern="[0-9]*" min="0" max="100" [text] [rg]="100" [value]="hslaText?.l" (keyup.enter)="onAcceptColor($event)" (newValue)="onLightnessInput($event)" />
          @if (cpAlphaChannel!=='disabled') {
            <input type="number" pattern="[0-9]+([\.,][0-9]{1,2})?" min="0" max="1" step="0.1" [text] [rg]="1" [value]="hslaText?.a" (keyup.enter)="onAcceptColor($event)" (newValue)="onAlphaInput($event)" />
          }
        </div>
        <div class="box">
          <div>H</div><div>S</div><div>L</div>@if (cpAlphaChannel!=='disabled') {
          <div>A</div>
        }
      </div>
    </div>
  }
  @if (!cpDisableInput && (cpColorMode || 1) === 1 ) {
    <div [style.display]="format !== 1 ? 'none' : 'block'" class="rgba-text">
      <div class="box">
        <input type="number" pattern="[0-9]*" min="0" max="255" [text] [rg]="255" [value]="rgbaText?.r" (keyup.enter)="onAcceptColor($event)" (newValue)="onRedInput($event)" />
        <input type="number" pattern="[0-9]*" min="0" max="255" [text] [rg]="255" [value]="rgbaText?.g" (keyup.enter)="onAcceptColor($event)" (newValue)="onGreenInput($event)" />
        <input type="number" pattern="[0-9]*" min="0" max="255" [text] [rg]="255" [value]="rgbaText?.b" (keyup.enter)="onAcceptColor($event)" (newValue)="onBlueInput($event)" />
        @if (cpAlphaChannel!=='disabled') {
          <input type="number" pattern="[0-9]+([\.,][0-9]{1,2})?" min="0" max="1" step="0.1" [text] [rg]="1" [value]="rgbaText?.a" (keyup.enter)="onAcceptColor($event)" (newValue)="onAlphaInput($event)" />
        }
      </div>
      <div class="box">
        <div>R</div><div>G</div><div>B</div>@if (cpAlphaChannel!=='disabled') {
        <div >A</div>
      }
    </div>
  </div>
}
@if (!cpDisableInput && (cpColorMode || 1) === 1) {
  <div class="hex-text" [class.hex-alpha]="cpAlphaChannel==='forced'"
    [style.display]="format !== 0 ? 'none' : 'block'">
    <div class="box">
      <input [text] [value]="hexText" (blur)="onHexInput(null)" (keyup.enter)="onAcceptColor($event)" (newValue)="onHexInput($event)"/>
      @if (cpAlphaChannel==='forced') {
        <input type="number" pattern="[0-9]+([\.,][0-9]{1,2})?" min="0" max="1" step="0.1" [text] [rg]="1" [value]="hexAlpha" (keyup.enter)="onAcceptColor($event)" (newValue)="onAlphaInput($event)"/>
      }
    </div>
    <div class="box">
      <div>Hex</div>
      @if (cpAlphaChannel==='forced') {
        <div>A</div>
      }
    </div>
  </div>
}
@if (!cpDisableInput && (cpColorMode || 1) === 2) {
  <div class="value-text">
    <div class="box">
      <input type="number" pattern="[0-9]*" min="0" max="100" [text] [rg]="100" [value]="hslaText?.l" (keyup.enter)="onAcceptColor($event)" (newValue)="onValueInput($event)" />
      @if (cpAlphaChannel!=='disabled') {
        <input type="number" pattern="[0-9]+([\.,][0-9]{1,2})?" min="0" max="1" step="0.1"  [text] [rg]="1" [value]="hslaText?.a" (keyup.enter)="onAcceptColor($event)" (newValue)="onAlphaInput($event)" />
      }
    </div>
    <div class="box">
      <div>V</div><div>A</div>
    </div>
  </div>
}
@if (!cpDisableInput && (cpColorMode || 1) === 1) {
  <div class="type-policy">
    <span class="type-policy-arrow" (click)="onFormatToggle(-1)"></span>
    <span class="type-policy-arrow" (click)="onFormatToggle(1)"></span>
  </div>
}
</div>
}

@if (cpOKButton || cpCancelButton) {
  <div class="button-area">
    @if (cpCancelButton) {
      <button type="button" class="{{cpCancelButtonClass}}" (click)="onCancelColor($event)">{{cpCancelButtonText}}</button>
    }
    @if (cpOKButton) {
      <button type="button" class="{{cpOKButtonClass}}" (click)="onAcceptColor($event)">{{cpOKButtonText}}</button>
    }
  </div>
}

@if (cpExtraTemplate) {
  <div class="extra-template">
    <ng-container *ngTemplateOutlet="cpExtraTemplate"></ng-container>
  </div>
}
</div>
